import {FileUploadUtils} from "./FileUploadUtils";
import moment from "moment";

export class FormUtils {

    static setupSubmitForm = (formChanges, fileChanges, isSingleFile, isFileJson, idMap) => {
        if ((!formChanges || Object.keys(formChanges).length === 0) && (!fileChanges || Object.keys(fileChanges).length === 0)) {
            throw Error("没有数据变更")
        }
        let files = {};
        let form = {};
        if (isFileJson) {
            files = FileUploadUtils.toFileUrlJsonMap(fileChanges)
        } else {
            files = FileUploadUtils.toFileUrlMap(fileChanges, isSingleFile)
        }

        form = {
            ...files,
            ...formChanges,
            ...(idMap ?? {})
        }

        Object.keys(form).forEach(k => {
            if (form[k] instanceof moment) {
                form[k] = form[k].valueOf()
            }
        })

        return form
    }

}